import React from "react";
import styles from "./Label.module.css";

export const Label = ({enabled, children}) => {
    return (
        <span className={styles.label} data-enabled={enabled}>{children}</span>
    )
}

